import { gql } from '@apollo/client';

const TRANSFER_ORDER_MASTERCODES = gql`
  mutation transferOrderMastercodes(
    $orderId: Int!
    $ownerEmail: String!
    $data: MastercodeTransferInput!
  ) {
    transferOrderMastercodes(where: { id: $orderId, ownerEmail: $ownerEmail }, data: $data) {
      count
    }
  }
`;

export default TRANSFER_ORDER_MASTERCODES;
